import ATable from './table'

import 'ant-design-vue/es/table/style/index'

export default ATable
